<template>
    <v-card>
        <v-card-title class="success white--text py-2 px-4">
            <span class="title pt-1">Update Absent Report</span>
            <v-spacer></v-spacer>
            <v-btn class="white--text my-0" icon flat small dark @click="closeAbsentReportDialog()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
        <v-layout row wrap>
            <v-flex xs12 :class="fieldColumnClass" class="pr-3">
                <v-layout row class="mb-2">
                    <div class="font-weight-medium width-150">Driver</div>
                    <div>{{ absent.driver }}</div>
                </v-layout>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium width-150">Bus Number</div>
                    <div>{{ absent.busNumber }}</div>
                </v-layout>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium width-150">Entered By</div>
                    <div>{{ absent.enteredBy }}</div>
                </v-layout>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium width-150">Entered On</div>
                    <div>{{ absent.enteredOn | time }}</div>
                </v-layout>

                <v-menu
                    v-model="absent.datePickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="absent.date"
                            :value="formatedDate(absent.date)"
                            label="Date"
                            prepend-icon="mdi-calendar"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="absent.date"></v-date-picker>
                </v-menu>

                <v-select
                    v-model="absent.absentReason"
                    label="Reason"
                    :items="reasons.map((r) => r.reason)"
                    ref="absentReason"
                    :rules="[rules.required]"
                ></v-select>
            </v-flex>

            <v-flex xs12 :class="fieldColumnClass" class="px-3">
                <v-card flat class="pa-3 mb-3 route-info-card">
                    <v-layout row align-center class="mb-2">
                        <v-icon color="success" small class="mr-2"
                            >mdi-routes</v-icon
                        >
                        <div class="font-weight-medium">Route Info</div>
                        <v-spacer></v-spacer>
                        <v-btn
                            small
                            outline
                            color="success"
                            class="ma-0"
                            @click="openChangeRoute"
                            >{{
                                absent.route_ID ? "Change Route" : "Assign Route"
                            }}</v-btn
                        >
                    </v-layout>

                    <v-layout row wrap v-if="absent.route_ID">
                        <v-flex xs6 class="mb-2">
                            <div class="caption grey--text">Route</div>
                            <div class="font-weight-medium">
                                {{ absent.routeIdentifier || "-"
                                }}<span v-if="absent.groupBy">
                                    ({{ absent.groupBy }})</span
                                >
                            </div>
                        </v-flex>
                        <v-flex xs6 class="mb-2">
                            <div class="caption grey--text">Time Start</div>
                            <div class="font-weight-medium">
                                {{ absent.timeStart || "-" }}
                            </div>
                        </v-flex>
                        <v-flex xs6 class="mb-2">
                            <div class="caption grey--text">Buildings</div>
                            <div class="font-weight-medium">
                                {{ absent.buildings || "-" }}
                            </div>
                        </v-flex>
                        <v-flex xs6 class="mb-2">
                            <div class="caption grey--text">Grades</div>
                            <div class="font-weight-medium">
                                {{ absent.grades || "-" }}
                            </div>
                        </v-flex>
                        <v-flex xs12 v-if="absent.description">
                            <div class="caption grey--text">Description</div>
                            <div class="font-weight-medium">
                                {{ absent.description }}
                            </div>
                        </v-flex>
                    </v-layout>
                    <div v-else class="grey--text">No Route Assigned</div>
                </v-card>

                <v-text-field v-model="absent.note" label="Note"></v-text-field>
                <v-text-field
                    v-model="absent.calendarNote"
                    label="Calendar Note"
                ></v-text-field>
                <v-select
                    v-model="absent.geoUpdated"
                    label="GEO Updated"
                    :items="['YES', 'NO', 'N/A']"
                ></v-select>

                <v-select
                    v-model="absent.notifiedDriver"
                    label="Notified Driver"
                    :items="['YES', 'NO', 'N/A']"
                ></v-select>

                <div class="mt-3 mb-2 font-weight-medium">Sub Driver</div>
                <v-btn-toggle
                    v-model="updateAbsentReport.subDriverListFilter"
                    @change="subDriverListFilterChanged"
                >
                    <v-btn flat value="all" class="pa-2">
                        <span>All</span>
                    </v-btn>
                    <v-btn flat value="not_occupied" class="pa-2">
                        <span>Not Occupied</span>
                    </v-btn>
                </v-btn-toggle>

                <v-autocomplete
                    v-model="updateAbsentReport.selectedSubDriver"
                    :disabled="updateAbsentReport.isUpdatingSubDriversList"
                    :items="updateAbsentReport.subDriversDisplayList"
                    hide-details
                    box
                    chips
                    color="success"
                    class="mt-3"
                    label="Select"
                    item-text="displayName"
                    item-value="id"
                    clearable
                >
                    <template v-slot:selection="data">
                        <v-chip
                            :selected="data.selected"
                            close
                            class="chip--select-multi"
                            @input="removeSubDriver(data.item)"
                        >
                            {{ data.item.displayName }}
                        </v-chip>
                    </template>
                    <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                            <v-list-tile-content
                                v-text="data.item"
                            ></v-list-tile-content>
                        </template>
                        <template v-else>
                            <v-list-tile-content>
                                <v-list-tile-title
                                    v-html="data.item.displayName"
                                ></v-list-tile-title>
                                <v-list-tile-sub-title
                                    v-html="data.item.group"
                                ></v-list-tile-sub-title>
                            </v-list-tile-content>
                        </template>
                    </template>
                </v-autocomplete>
            </v-flex>

            <v-flex xs12 sm4 class="pl-3" v-if="canEditExistingDeductions">
                <v-card flat class="pa-3 mb-3 deduction-info-card">
                    <v-layout row align-center class="mb-2">
                        <v-icon color="orange darken-1" small class="mr-2"
                            >mdi-currency-usd</v-icon
                        >
                        <div class="font-weight-medium">
                            Deduction for {{ formatedDate(absent.date) }}
                        </div>
                        <v-chip
                            v-if="isBackdated"
                            small
                            color="orange"
                            text-color="white"
                            class="ml-2"
                        >
                            Backdated
                        </v-chip>
                        <v-spacer></v-spacer>
                        <v-progress-circular
                            v-if="deductionLoading"
                            indeterminate
                            size="18"
                            color="success"
                        ></v-progress-circular>
                    </v-layout>

                    <template v-if="deduction && !deductionLoading">
                        <div class="caption grey--text mb-2">
                            {{ deduction.preview.payAbsentCount }} of
                            {{ deduction.preview.payRouteCount }} pay routes
                            on this day
                            <span v-if="deduction.preview.category">
                                — {{ categoryLabel(deduction.preview.category) }}
                            </span>
                        </div>

                        <div
                            v-if="deduction.preview.existing"
                            class="mb-3 body-2 current-deduction-box"
                        >
                            <div class="font-weight-medium">
                                Current: ${{ formatMoney(deduction.preview.existing.amount) }}
                                ({{ presetLabel(deduction.preview.existing.preset) }})
                            </div>
                            <div
                                v-if="deduction.preview.existing.enteredBy"
                                class="caption grey--text"
                            >
                                Entered by
                                {{ deduction.preview.existing.enteredBy }}
                                <span v-if="deduction.preview.existing.enteredOn">
                                    on
                                    {{ deduction.preview.existing.enteredOn | time }}
                                </span>
                            </div>
                        </div>
                        <div v-else class="mb-3 no-deduction-banner">
                            <v-icon color="#c62828" small class="mr-2"
                                >mdi-alert-circle</v-icon
                            >
                            <span>No deduction recorded yet for this day</span>
                        </div>

                        <v-radio-group
                            v-model="deductionForm.selectedPreset"
                            hide-details
                            class="mt-0"
                        >
                            <v-radio
                                v-for="suggestion in deduction.preview.suggestions.filter((s) => s.preset !== 'NO_DEDUCT')"
                                :key="suggestion.preset"
                                :value="suggestion.preset"
                                color="success"
                                :label="suggestion.label + ' — $' + formatMoney(suggestion.amount)"
                            ></v-radio>
                            <v-radio
                                value="MANUAL"
                                color="success"
                                label="Custom amount"
                            ></v-radio>
                            <v-radio
                                v-for="suggestion in deduction.preview.suggestions.filter((s) => s.preset === 'NO_DEDUCT')"
                                :key="suggestion.preset"
                                :value="suggestion.preset"
                                color="success"
                                :label="suggestion.label + ' — $' + formatMoney(suggestion.amount)"
                            ></v-radio>
                        </v-radio-group>
                        <v-text-field
                            v-if="deductionForm.selectedPreset === 'MANUAL'"
                            v-model="deductionForm.customAmount"
                            label="Amount"
                            type="number"
                            prefix="$"
                            class="mt-1"
                        ></v-text-field>
                        <v-text-field
                            v-if="deductionForm.selectedPreset === 'MANUAL'"
                            v-model="deductionForm.customReason"
                            label="Reason (optional)"
                            class="mt-1"
                        ></v-text-field>
                        <v-text-field
                            v-if="deductionForm.selectedPreset === 'NO_DEDUCT'"
                            v-model="deductionForm.noDeductReason"
                            label="Reason for no deduct"
                            class="mt-1"
                        ></v-text-field>
                        <v-layout row class="mt-2">
                            <div class="mr-3">
                                <div class="caption grey--text mb-1">
                                    Absent from
                                </div>
                                <DxDateBox
                                    type="time"
                                    picker-type="list"
                                    :interval="15"
                                    :width="150"
                                    :value="asTimeValue(deductionForm.timeFrom)"
                                    :show-clear-button="true"
                                    @value-changed="onDeductionTimeChanged('timeFrom', $event)"
                                />
                            </div>
                            <div>
                                <div class="caption grey--text mb-1">
                                    Absent to
                                </div>
                                <DxDateBox
                                    type="time"
                                    picker-type="list"
                                    :interval="15"
                                    :width="150"
                                    :value="asTimeValue(deductionForm.timeTo)"
                                    :show-clear-button="true"
                                    @value-changed="onDeductionTimeChanged('timeTo', $event)"
                                />
                            </div>
                        </v-layout>
                        <div class="caption grey--text mt-1">
                            This deduction covers every absence for this driver
                            on this date.
                        </div>

                        <v-btn
                            small
                            outline
                            color="success"
                            class="ma-0 mt-2"
                            :loading="deductionSaving"
                            @click="saveDeductionForAbsent"
                        >
                            Save Deduction
                        </v-btn>
                    </template>
                </v-card>

                <v-card
                    v-if="deduction && deduction.absences && deduction.absences.length"
                    flat
                    class="absences-panel-card"
                >
                    <div
                        class="absences-panel-header"
                        @click="absencesExpanded = !absencesExpanded"
                    >
                        <v-icon small color="grey darken-1" class="mr-2"
                            >mdi-format-list-bulleted</v-icon
                        >
                        <span class="font-weight-medium">Absences this day</span>
                        <v-chip small class="ml-2 absences-count-chip">{{
                            deduction.absences.length
                        }}</v-chip>
                        <v-spacer></v-spacer>
                        <v-icon small color="grey darken-1">{{
                            absencesExpanded ? "mdi-chevron-up" : "mdi-chevron-down"
                        }}</v-icon>
                    </div>

                    <div v-if="absencesExpanded" class="absences-panel-body">
                        <template v-for="(group, gIndex) in groupedAbsences">
                            <div :key="'h-' + group.name" class="absence-group-header">
                                {{ group.name }}
                                <span class="grey--text">({{ group.rows.length }})</span>
                            </div>
                            <div
                                v-for="row in group.rows"
                                :key="row.id"
                                class="absence-grid-row"
                            >
                                <div class="absence-grid-main">
                                    <div class="absence-grid-cell absence-grid-time">
                                        {{ absenceTimeLabel(row) }}
                                    </div>
                                    <div
                                        v-if="row.routeIdentifier"
                                        class="absence-grid-cell absence-grid-route"
                                    >
                                        {{ row.routeIdentifier }}
                                    </div>
                                    <div class="absence-grid-cell absence-grid-reason grey--text">
                                        {{ row.absentReason || "-" }}
                                    </div>
                                </div>
                                <div v-if="rowNote(row)" class="absence-grid-note">
                                    {{ rowNote(row) }}
                                </div>
                            </div>
                            <v-divider
                                v-if="gIndex + 1 < groupedAbsences.length"
                                :key="'d-' + group.name"
                            ></v-divider>
                        </template>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>

        <!-- <v-text-field
                    class="mx-2 mb-2"
                    v-model="rowClicked.description"
                    label="Description"
                    ref="description"
                    :rules="[rules.required]"
                ></v-text-field> -->
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3">
            <v-spacer></v-spacer>
            <v-btn color="default" dark @click="closeAbsentReportDialog()"
                >Cancel</v-btn
            >
            <v-btn color="warning" dark @click="openDeleteImpact">Delete</v-btn>
            <v-btn
                :loading="processing"
                color="success"
                @click="saveAbsentReport()"
            >
                Save
            </v-btn>
        </v-card-actions>

        <deduction-impact-dialog
            v-model="payDialog"
            :title="payMode === 'delete' ? 'Delete Absent Report' : 'Pay will change'"
            :intro="
                payMode === 'delete'
                    ? 'This absence will be deleted.'
                    : 'The date change also changes the deduction for these days.'
            "
            :confirm-text="payMode === 'delete' ? 'Delete' : 'Save'"
            :loading="payImpactLoading"
            :confirm-loading="processing"
            :days="payImpactDays"
            @confirm="onPayConfirm"
        ></deduction-impact-dialog>

        <v-dialog persistent v-model="changeRouteDialog" max-width="1000">
            <change-route
                :selected="changeRouteSelected"
                :reload="reload"
                :close="closeChangeRoute"
                :onAllSaved="onChangeRouteSaved"
            ></change-route>
        </v-dialog>
    </v-card>
</template>

<script>
import moment from "moment";
import DxDateBox from "devextreme-vue/date-box";
import { getDomain, sum, toISOLocal } from "../../utils/helpers.js";
import changeRoute from "./ChangeRoute.vue";
import deductionImpactDialog from "./components/DeductionImpactDialog.vue";
import { canEditExistingDeductions } from "./deductionAccess";

export default {
    components: {
        DxDateBox,
        changeRoute,
        deductionImpactDialog,
    },
    props: {
        absent: Object,
        reload: Function,
        closeAbsentReportDialog: Function,
    },
    data() {
        return {
            processing: false,
            originalDate: "",
            payDialog: false,
            payMode: "",
            payImpactLoading: false,
            payImpactDays: [],

            changeRouteDialog: false,
            changeRouteSelected: [],

            updateAbsentReport: {
                selectedSubDriver: "",
                isUpdatingSubDriversList: false,
                subDriversDisplayList: [],
                subDrivers: [],
                subDriverListFilter: "all",
            },

            reasons: [],

            deduction: null,
            deductionLoading: false,
            deductionSaving: false,
            absencesExpanded: false,
            deductionForm: {
                selectedPreset: "",
                noDeductReason: "",
                customAmount: "",
                customReason: "",
                timeFrom: null,
                timeTo: null,
            },

            rules: {
                required: (value) => !!value || "Required.",
            },
        };
    },
    async created() {},
    computed: {
        canEditExistingDeductions() {
            return canEditExistingDeductions(this.$store);
        },
        // Widen the driver/route columns when there's no deduction column to show.
        fieldColumnClass() {
            return this.canEditExistingDeductions ? "sm4" : "sm6";
        },
        isBackdated() {
            return (
                this.absent &&
                this.absent.date &&
                moment(this.absent.date).isBefore(moment(), "day")
            );
        },
        // Absences for this day grouped by route kind (AM/PM/CUSTOM/FAM/PPM), in a fixed
        // display order, for the expandable grid at the bottom of the deduction column.
        groupedAbsences() {
            if (!this.deduction || !this.deduction.absences) return [];

            const order = ["AM", "PM", "CUSTOM", "FAM", "PPM"];
            const groups = {};

            this.deduction.absences.forEach((row) => {
                const name = row.groupBy || "Other";
                if (!groups[name]) groups[name] = [];
                groups[name].push(row);
            });

            return Object.keys(groups)
                .sort((a, b) => {
                    const ai = order.indexOf(a);
                    const bi = order.indexOf(b);
                    return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
                })
                .map((name) => ({ name: name, rows: groups[name] }));
        },
    },
    watch: {
        absent(newValue, oldValue) {
            this.absencesExpanded = false;
            this.loadSubDriverList();
            this.loadReasons();
            this.loadDeduction();
        },
    },
    methods: {
        async loadReasons() {
            this.reasons = await this.$http.get(
                "api/driverAbsent/GetDriverAbsentReasons",
            );
        },
        async loadSubDriverList() {
            this.updateAbsentReport.selectedSubDriver = "";

            if (this.absent.date.includes("Z")) {
                this.absent.date = toISOLocal(
                    new Date(this.absent.date),
                ).substr(0, 10);
            } else {
                this.absent.date = new Date(this.absent.date)
                    .toISOString()
                    .substr(0, 10);
            }

            this.originalDate = moment(this.absent.date).format("YYYY-MM-DD");

            const response = await this.$http.post(
                "api/driverAbsent/getSubDrivers",
                [this.absent.id],
            );

            this.updateAbsentReport.subDrivers = response
                .map((driver) => {
                    driver.displayName =
                        (driver.nameH ? driver.nameH : driver.name) +
                        " (" +
                        driver.busNumber +
                        ")";

                    driver.group = driver.isOccupied
                        ? "Occupied"
                        : "Not Occupied";

                    if (driver.position == "Substitute")
                        driver.group += ` <span class='substitute-option'>Substitute</span>`;

                    return driver;
                })
                .sort((a, b) => {
                    if (a.group < b.group) {
                        return -1;
                    }
                    if (a.group > b.group) {
                        return 1;
                    }
                    return 0;
                });

            this.updateAbsentReport.subDrivers = this.updateAbsentReport.subDrivers.reduce(
                (acc, curr) => {
                    const { group } = curr;

                    let groupHeader = group;

                    groupHeader = groupHeader.replace(
                        ` <span class='substitute-option'>Substitute</span>`,
                        ``,
                    );

                    const foundIndex = acc.findIndex(
                        (item) => item.group === groupHeader,
                    );
                    // if group is not yet added
                    if (foundIndex === -1) {
                        // add divider after full list of Not Occupied
                        if (groupHeader === "Occupied") {
                            acc.push({ divider: true });
                        }
                        acc.push({
                            header: groupHeader.toUpperCase(),
                        });
                    }
                    acc.push(curr);
                    return acc;
                },
                [],
            );

            this.updateAbsentReport.subDriversDisplayList = this.updateAbsentReport.subDrivers;

            const selectedSubDriver = this.updateAbsentReport.subDrivers.find(
                (sd) => sd.id == this.absent.subDriver_Bus_ID,
            );

            if (this.absent.subDriver_Bus_ID && selectedSubDriver) {
                this.updateAbsentReport.selectedSubDriver = selectedSubDriver;
            } else {
                this.updateAbsentReport.selectedSubDriver = "";
            }
        },
        removeSubDriver(item) {
            if (this.updateAbsentReportDialog) {
                this.updateAbsentReport.selectedSubDriver = "";
            } else {
                this.updateAbsentReport.selectedSubDriver = "";
            }
        },
        subDriverListFilterChanged(value) {
            this.updateAbsentReport.selectedSubDriver = "";
            this.updateAbsentReport.subDriversDisplayList =
                value == "all"
                    ? this.updateAbsentReport.subDrivers
                    : this.updateAbsentReport.subDrivers.filter(
                          (s) => s.group == "Not Occupied",
                      );
        },
        formatedDate(date) {
            return date ? moment(date).format("L") : "";
        },
        formatMoney(value) {
            return Number(value || 0).toFixed(2);
        },
        absenceTimeLabel(row) {
            if (row.timeStart) return row.timeStart;
            return row.routeIdentifier ? "No time" : "No route";
        },
        rowNote(row) {
            if (!row) return "";
            if (
                this.absent &&
                row.id == this.absent.id &&
                this.absent.note
            ) {
                return this.absent.note;
            }
            return row.note || "";
        },
        categoryLabel(category) {
            if (category === "AM+CUSTOM") return "AM + CUSTOM";
            if (category === "PM+CUSTOM") return "PM + CUSTOM";
            return category || "";
        },
        presetLabel(preset) {
            const map = {
                DAY: "Full day",
                AM: "AM",
                PM: "PM",
                TRIP: "Trip",
                ROUTES: "By routes",
                DURATION: "By duration",
                TIME: "By missing time",
                NO_DEDUCT: "No deduct",
                MANUAL: "Custom amount",
            };
            return map[preset] || preset || "—";
        },
        asTimeValue(value) {
            if (!value) return null;
            if (moment.isDate(value)) {
                return moment(value).isValid() ? value : null;
            }
            const parsed = moment(value, ["h:mm A", "HH:mm", "HH:mm:ss"], true);
            return parsed.isValid() ? parsed.toDate() : null;
        },
        parseDeductionTime(value) {
            if (!value) return null;
            const parsed = moment.isDate(value)
                ? moment(value)
                : moment(value, ["h:mm A", "HH:mm", "HH:mm:ss"], true);
            return parsed.isValid() ? parsed.format("HH:mm:ss") : null;
        },
        onDeductionTimeChanged(field, event) {
            const value = event && event.value !== undefined ? event.value : null;
            const next = this.asTimeValue(value);
            if (!next && !(event && event.event)) return;
            if (this.parseDeductionTime(this.deductionForm[field]) === this.parseDeductionTime(next)) {
                return;
            }
            this.deductionForm[field] = next;
        },
        // Loads the current, real deduction state for this absence's driver/date (across
        // whatever routes are actually absent that day) — used both to show what's already
        // resolved and to catch up absences that were entered before now with no deduction yet.
        async loadDeduction() {
            this.deduction = null;

            if (!this.canEditExistingDeductions) return;
            if (!this.absent || !this.absent.id) return;

            this.deductionLoading = true;
            try {
                const response = await this.$http.get(
                    "api/driverAbsent/getDeductionForAbsent?absentId=" +
                        this.absent.id,
                );

                this.deduction = response;

                const existing = response.preview.existing;
                const selectedPreset =
                    (existing && existing.preset) ||
                    response.preview.recommendedPreset ||
                    "NO_DEDUCT";

                this.deductionForm = {
                    selectedPreset: selectedPreset,
                    noDeductReason: (existing && existing.noDeductReason) || "",
                    customAmount:
                        existing && existing.preset === "MANUAL"
                            ? existing.amount
                            : "",
                    customReason:
                        existing && existing.preset === "MANUAL"
                            ? existing.noDeductReason || ""
                            : "",
                    timeFrom: existing && existing.timeFrom,
                    timeTo: existing && existing.timeTo,
                    timeFromMenu: false,
                    timeToMenu: false,
                };
            } catch (e) {
                this.deduction = null;
            } finally {
                this.deductionLoading = false;
            }
        },
        async refreshDeductionPreview() {
            if (!this.deduction) return;

            try {
                const preview = await this.$http.post(
                    "api/driverAbsent/previewDeduction",
                    {
                        driverBusID: this.absent.driver_Bus_ID,
                        date: this.absent.date,
                        kind: this.deduction.kind,
                        timeFrom: this.parseDeductionTime(
                            this.deductionForm.timeFrom,
                        ),
                        timeTo: this.parseDeductionTime(
                            this.deductionForm.timeTo,
                        ),
                    },
                );
                this.deduction.preview = preview;
            } catch (e) {
                // keep the prior preview if the refresh fails
            }
        },
        deductionFormError() {
            // Non-admins never see the deduction section, so it must never be validated or
            // saved on their behalf either — even if some stale local state slipped through.
            if (!this.canEditExistingDeductions) return "";
            if (!this.deduction || !this.deductionForm.selectedPreset) return "";

            if (
                this.deductionForm.selectedPreset === "NO_DEDUCT" &&
                !this.deductionForm.noDeductReason
            ) {
                return "A reason is required when not deducting";
            }

            if (
                this.deductionForm.selectedPreset === "MANUAL" &&
                (this.deductionForm.customAmount === "" ||
                    this.deductionForm.customAmount == null ||
                    isNaN(Number(this.deductionForm.customAmount)))
            ) {
                return "Enter the custom amount";
            }

            return "";
        },
        deductionPayload() {
            // Same rule as above: a non-admin's Save must never touch deduction data they
            // can't see, regardless of what happens to be sitting in local state.
            if (!this.canEditExistingDeductions) return null;
            if (!this.deduction || !this.deductionForm.selectedPreset) return null;

            const suggestion = (this.deduction.preview.suggestions || []).find(
                (s) => s.preset === this.deductionForm.selectedPreset,
            );
            const amount =
                this.deductionForm.selectedPreset === "MANUAL"
                    ? Number(this.deductionForm.customAmount)
                    : suggestion
                    ? suggestion.amount
                    : this.deduction.preview.recommendedAmount;

            return {
                driverBusID: this.absent.driver_Bus_ID,
                date: this.absent.date,
                kind: this.deduction.kind,
                category: this.deduction.preview.category,
                preset: this.deductionForm.selectedPreset,
                amount: amount,
                noDeductReason:
                    this.deductionForm.selectedPreset === "MANUAL"
                        ? this.deductionForm.customReason
                        : this.deductionForm.noDeductReason,
                timeFrom: this.parseDeductionTime(this.deductionForm.timeFrom),
                timeTo: this.parseDeductionTime(this.deductionForm.timeTo),
                updateOutWindow: true,
                enteredBy: this.$store.state.authentication.user,
            };
        },
        async saveDeductionForAbsent() {
            const error = this.deductionFormError();
            if (error) {
                return this.$notify({
                    text: error,
                    group: "notification",
                    type: "error",
                });
            }

            const payload = this.deductionPayload();
            if (!payload) return;

            try {
                this.deductionSaving = true;

                await this.$http.post(
                    "api/driverAbsent/saveDeduction",
                    payload,
                );

                this.$notify({
                    group: "notification",
                    text: "Deduction saved",
                    type: "success",
                });

                await this.loadDeduction();
            } catch (e) {
                this.$notify({
                    group: "notification",
                    text: (e && e.body) || "Failed to save deduction",
                    type: "error",
                });
            } finally {
                this.deductionSaving = false;
            }
        },
        async openDeleteImpact() {
            this.payMode = "delete";
            await this.loadPayImpact([
                {
                    absentID: this.absent.id,
                    action: "delete",
                },
            ]);
        },
        async loadPayImpact(mutations) {
            this.payImpactDays = [];
            this.payDialog = true;
            this.payImpactLoading = true;
            try {
                this.payImpactDays =
                    (await this.$http.post(
                        "api/driverAbsent/previewPayImpact",
                        mutations,
                    )) || [];
            } catch (e) {
                this.payImpactDays = [];
                this.$notify({
                    group: "notification",
                    text: "Could not check how pay will change",
                    type: "error",
                });
            } finally {
                this.payImpactLoading = false;
            }
        },
        async onPayConfirm(decisions) {
            if (this.payMode === "delete") {
                await this.commitDelete(decisions);
            } else {
                await this.commitSave(decisions);
            }
        },
        async commitDelete(decisions) {
            try {
                this.processing = true;

                await this.$http.post("api/driverAbsent/deleteWithPay", {
                    ids: [this.absent.id],
                    decisions: decisions || [],
                });

                this.processing = false;
                this.payDialog = false;
                this.closeAbsentReportDialog();

                this.$notify({
                    group: "notification",
                    text: "Absent Report Deleted",
                    type: "success",
                });

                this.reload();
            } catch (e) {
                this.processing = false;
                this.$notify({
                    group: "notification",
                    text:
                        (e && e.body && e.body.message) ||
                        "Delete was not saved. Check the pay choices and try again.",
                    type: "error",
                });
            }
        },
        async saveAbsentReport() {
            if (!this.absent.date) {
                return this.$notify({
                    text: "Date is required",
                    group: "notification",
                    type: "error",
                });
            }

            if (!this.$refs.absentReason.validate(true)) return;

            const deductionError = this.deductionFormError();
            if (deductionError) {
                return this.$notify({
                    text: deductionError,
                    group: "notification",
                    type: "error",
                });
            }

            const nextDate = moment(this.absent.date).format("YYYY-MM-DD");
            if (nextDate !== this.originalDate) {
                this.payMode = "save";
                await this.loadPayImpact([
                    {
                        absentID: this.absent.id,
                        action: "date",
                        date: nextDate,
                    },
                ]);
                return;
            }

            await this.commitSave([]);
        },
        async commitSave(decisions) {
            try {
                this.processing = true;

                const selectedSubDriverID =
                    typeof this.updateAbsentReport.selectedSubDriver ===
                    "number"
                        ? this.updateAbsentReport.selectedSubDriver
                        : this.updateAbsentReport.selectedSubDriver.id;

                const subDriver = this.updateAbsentReport.subDrivers.find(
                    (sd) => sd.id == selectedSubDriverID,
                );

                await this.$http.post("api/driverAbsent/saveEdits", {
                    absents: [
                        {
                            id: this.absent.id,
                            driver_Bus_ID: this.absent.driver_Bus_ID,
                            route_ID: this.absent.route_ID,
                            date: this.absent.date,
                            subDriver_Bus_ID: subDriver ? subDriver.id : null,
                            absentReason: this.absent.absentReason,
                            absentReasonID: this.getReasonID(
                                this.absent.absentReason,
                            ),
                            note: this.absent.note,
                            calendarNote: this.absent.calendarNote,
                            geoUpdated: this.absent.geoUpdated,
                            notifiedDriver: this.absent.notifiedDriver,
                        },
                    ],
                    decisions: decisions || [],
                });

                const deduction = this.deductionPayload();
                if (deduction) {
                    await this.$http.post(
                        "api/driverAbsent/saveDeduction",
                        deduction,
                    );
                }

                this.processing = false;
                this.payDialog = false;
                this.closeAbsentReportDialog();

                this.$notify({
                    group: "notification",
                    text: "Changes Saved",
                    type: "success",
                });

                this.reload();
            } catch (e) {
                console.log(e);
                this.processing = false;
                this.$notify({
                    group: "notification",
                    text:
                        (e && e.body && e.body.message) ||
                        "Changes were not saved. Check the pay choices and try again.",
                    type: "error",
                });
            }
        },
        getReasonID(reason) {
            const data = this.reasons.find((r) => r.reason == reason);

            return data ? data.id : null;
        },
        openChangeRoute() {
            this.changeRouteSelected = [this.absent];
            this.changeRouteDialog = true;
        },
        closeChangeRoute() {
            this.changeRouteDialog = false;
        },
        onChangeRouteSaved() {
            this.closeAbsentReportDialog();
        },
    },
};
</script>
<style>
.scroll-container {
    height: 100%;
    overflow-y: scroll;
    backface-visibility: hidden;
}
.route-info-card.v-card {
    background-color: #f4faf5 !important;
    border: 1px solid #c8e6c9 !important;
    border-left: 4px solid #4caf50 !important;
    border-radius: 6px !important;
    box-shadow: none !important;
}
.deduction-info-card.v-card {
    background-color: #fff8f0 !important;
    border: 1px solid #ffe0b2 !important;
    border-left: 4px solid #fb8c00 !important;
    border-radius: 6px !important;
    box-shadow: none !important;
}
.current-deduction-box {
    background-color: #fff;
    border: 1px solid #ffe0b2;
    border-radius: 4px;
    padding: 8px 10px;
}
.no-deduction-banner {
    display: flex;
    align-items: center;
    background-color: #ffebee;
    border: 1px solid #ef9a9a;
    border-left: 4px solid #c62828;
    border-radius: 4px;
    padding: 8px 10px;
    color: #c62828;
    font-weight: 600;
}
.absences-panel-card.v-card {
    border: 1px solid #e0e0e0 !important;
    border-radius: 6px !important;
    box-shadow: none !important;
    padding: 0;
    overflow: hidden;
}
.absences-panel-header {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    cursor: pointer;
    background-color: #fafafa;
}
.absences-panel-header:hover {
    background-color: #f0f0f0;
}
.absences-count-chip.v-chip {
    background-color: #eeeeee;
    height: 20px;
}
.absences-panel-body {
    padding: 4px 12px 10px;
}
.absence-group-header {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    font-weight: 600;
    color: #757575;
    margin: 10px 0 4px;
}
.absence-group-header:first-child {
    margin-top: 4px;
}
.absence-grid-row {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 4px 0;
    font-size: 13px;
    border-bottom: 1px solid #f5f5f5;
}
.absence-grid-main {
    display: flex;
    align-items: baseline;
}
.absence-grid-note {
    margin: 1px 0 2px 90px;
    padding-left: 8px;
    border-left: 2px solid #cfd8dc;
    font-size: 12px;
    color: #455a64;
    line-height: 1.3;
}
.absence-grid-row:last-child {
    border-bottom: none;
}
.absence-grid-cell {
    padding-right: 10px;
}
.absence-grid-time {
    flex: 0 0 90px;
    font-weight: 500;
}
.absence-grid-route {
    flex: 1 1 auto;
}
.absence-grid-reason {
    flex: 0 0 auto;
    text-align: right;
    max-width: 40%;
}
.substitute-option {
    font-size: 12px;
    background-color: purple;
    color: #fff;
    width: fit-content;
    padding: 3px;
    margin-bottom: 2px;
    border-radius: 5px;
}
</style>
